<template>
    <div :class="['news-item',  `news-item-${item.template}`]">
        <news-tpl-3 v-if="item.template == 3" :item="item"></news-tpl-3>
        <news-tpl-4 v-else :item="item"></news-tpl-4>
    </div>
</template>

<script>
import NewsTpl3 from './news-tpl-3';
import NewsTpl4 from './news-tpl-4';

export default {
    components: {
        NewsTpl3,
        NewsTpl4
    },
    props: {
        item: {
            type: Object,
            default() {
                return {};
            }
        }
    }
}
</script>

<style lang="less" scoped>
.news-item {
    position: relative;
    padding: 10px 0;
    &:last-of-type:after {
        display: none;
    }
    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 1px;
        background: #d1d3d6;
        transform-origin: 50% 100% 0;
    }
    .news-link {
        display: block;
    }
}
.hairlines .news-item:after {
    transform: scaleY(0.5);
}
html[data-dpr='3'] .news-item:after {
    transform: scaleY(0.33) !important;
}
html[data-dpr='4'] .news-item:after {
    transform: scaleY(0.25) !important;
}
</style>



// WEBPACK FOOTER //
// src/common/component/news-stream/news-item.vue